<template>
  <div>
    <div class="modal show_modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg-custom modal-dialog-centered">
        <div class="modal-content" style="margin-top: 0px; height: 100vh">
          <div
            class="modal-header"
            style="background: white; border-bottom: 1px solid #eaeaea"
          >
            <div class="container-fluid">
              <button
                type="button"
                style="position: absolute"
                @click="ClosePaid()"
                class="btn btn-small"
              >
                <v-icon class="">mdi-arrow-left</v-icon>
                {{ $t("Back") }}
              </button>
              <div class="text-center mt-2 mb-2" style="color: black">
                <h4>{{ $t(container) }}</h4>
              </div>
            </div>
          </div>

          <div
            class="modal-body p-4"
            style="height: auto; margin-top: -24px; margin: auto"
          >
            <div class="wrap-payform">
              <div class="lef-menu-wrap">
                <ul class="left-aside-paid">
                  <li
                    @click="container = 'PAYMENT'"
                    :class="{ active: container == 'PAYMENT' }"
                  >
                    <icon icon="hard-drive" />
                    <p>Payment</p>
                  </li>
                  <li
                    @click="container = 'CUSTOMER'"
                    :class="{ active: container == 'CUSTOMER' }"
                  >
                    <icon icon="user" />
                    <p>Customer</p>
                  </li>
                  <li
                    @click="container = 'NOTE'"
                    :class="{ active: container == 'NOTE' }"
                  >
                    <icon icon="edit-2" />
                    <p>Note</p>
                  </li>
                  <li>
                    <toggle-button
                      v-model="print_preview"
                      :width="70"
                      :height="30"
                      :labels="{ checked: 'Print', unchecked: 'Off' }"
                    />
                    <!-- <p class="mt-2"> {{ $t("Print Order") }}</p>  -->
                  </li>
                </ul>
              </div>
              <div
                class="container box-payform-inside"
                v-if="container == 'PAYMENT'"
              >
                <div class="d-flex justify-content-center">
                  <div class="w-50 right mr-5" style="max-width: 400px">
                    <h6 class="mt-4 mb-4">{{ $t("Cash Received") }}</h6>
                    <!-- cash receive list  -->

                    <div
                      v-for="(currency, index_currency) of allExchange"
                      :key="index_currency + 'A'"
                    >
                      <div class="d-flex mb-2">
                        <div class="ml-2 input-group">
                          <input
                            type="number"
                            class="form-control"
                            :id="`name-${currency.code}`"
                            v-model="currency.cash_enter"
                            @focus="index_all_exchange = index_currency"
                            min="0"
                            :placeholder="currency.code"
                            style="font-size: 25px"
                          />
                          <div
                            class="input-group-prepend"
                            @click="currency.cash_enter = ''"
                          >
                            <span class="input-group-text">
                              <v-icon :size="30">mdi-close-circle</v-icon></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- keypad  -->
                    <button
                      v-for="(btn, index) of shortcutAmounts"
                      :key="index"
                      class="btn-shortcut mt-4"
                      @click="setAmountBySort(btn.value, index_all_exchange)"
                    >
                      {{ btn.value }}
                      {{ allExchange[index_all_exchange].code }}
                    </button>

                    <key-pad-order
                      @onChange="keyNumberChangeAmount"
                      :input="cashEnter"
                      inputName="cash_change"
                      ref="key-pad-cash-change"
                    />
                  </div>
                  <div class="w-50 left" style="max-width: 400px">
                    <h6 class="mt-3">{{ $t("Amount to paid") }}</h6>
                    <div class="d-flex mb-5 mt-4">
                      <div
                        class="text-center w-50"
                        style="border-right: 1px solid"
                      >
                        <h4>
                          <strong>
                            {{ invoice.currency_code }}
                            {{
                              (invoice.amount_to_be_paid - invoice.amount_paid)
                                | commaNumberRate(
                                  invoice.exchangerate,
                                  invoice.currency_code
                                )
                            }}
                          </strong>
                        </h4>
                      </div>
                      <div class="w-50 text-center">
                        <span
                          v-for="(currency, index_currency) of JSON.parse(
                            invoice.all_exchangerate
                          )"
                          :key="index_currency"
                        >
                          <span v-if="currency.code != invoice.currency_code">
                            <h4>
                              {{ currency.code }}
                              {{
                                (invoice.amount_to_be_paid -
                                  invoice.amount_paid)
                                  | commaNumberRate(
                                    currency.rate,
                                    currency.code
                                  )
                              }}
                            </h4>
                          </span>
                        </span>
                      </div>
                    </div>

                    <!-- Change Currency -->

                    <h6 class="mt-2" v-if="cash_change < 0">
                      {{ $t("Balance") }}
                    </h6>
                    <h6 class="mt-2" v-else>{{ $t("Change") }}</h6>

                    <div class="d-flex mb-4 mt-2">
                      <div
                        class="w-50 text-center"
                        style="border-right: 1px solid"
                      >
                        <h4>
                          <strong>
                            {{ invoice.currency_code }}
                            {{
                              cash_change
                                | commaNumberRate(
                                  invoice.exchangerate,
                                  invoice.currency_code
                                )
                            }}
                          </strong>
                        </h4>
                      </div>
                      <div class="w-50 text-center">
                        <span
                          v-for="currency of restaurant.currencies"
                          :key="currency.code"
                        >
                          <span v-if="currency.code != invoice.currency_code">
                            <h4>
                              {{ currency.code }}
                              {{
                                cash_change
                                  | commaNumberRate(
                                    currency.rate,
                                    currency.code
                                  )
                              }}
                            </h4>
                          </span>
                        </span>
                      </div>
                    </div>

                    <!-- button paymnet type -->
                    <div class="option-type-wrap mb-2">
                      <button
                        class="btn btn-option-type"
                        @click="payment_type = type"
                        v-for="(type, index) of paymentTypes"
                        :key="index"
                        v-bind:class="{ active: payment_type.id == type.id }"
                        v-bind:style="{ 
                          height: '60px',
                        }"
                      >
                        {{ type.title }}
                      </button>
                      <button
                        v-if="isAllowCredit == true"
                        class="btn btn-option-type"
                        @click="(payment_type = creditOption), makeCredit()"
                        v-bind:style="{ 
                          height: '60px',
                        }"
                      >
                        {{ $t("Credit") }}
                      </button>
                    </div>

                    <button
                      class="btn btn-block btn-confirm mt-2"
                      @click="exact()"
                    >
                      {{ $t("Exact") }}
                    </button>

                    <template
                      v-if="this.isAllowCredit == true && this.cash_change < 0"
                    >
                      <button
                        :disabled="ValidCheckOut == false"
                        class="btn btn-block shadow-sm btn-confirm mt-2"
                        @click="openModalCredit()"
                      >
                        {{ $t("Check Out") }}
                      </button>
                    </template>
                    <template v-else>
                      <button
                        :disabled="ValidCheckOut == false"
                        class="btn btn-block shadow-sm btn-confirm mt-2"
                        @click="submitOrder(false)"
                      >
                        {{ $t("Check Out") }}
                      </button>
                    </template>
                  </div>
                </div>
              </div>

              <div
                class="container box-payform-inside"
                v-if="container == 'CUSTOMER'"
              >
                <div class="d-flex justify-content-center">
                  <div class="p-5" style="width: 100%; max-width: 700px">
                    <div class="row">
                      <label class="col-sm-2 col-form-label"> </label>
                      <div class="col-sm-10">
                        <button
                          type="button"
                          class="btn btn-option-type"
                          @click="modal_customer = true"
                        >
                          <icon icon="user-plus" /> {{ $t("Select customer") }}
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label">
                        {{ $t("Customer") }}</label
                      >
                      <div class="col-sm-10">
                        <input
                          type="text"
                          readonly
                          class="form-control"
                          v-model="customer.name"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label">
                        {{ $t("Email") }}</label
                      >
                      <div class="col-sm-10">
                        <input
                          type="text"
                          readonly
                          class="form-control"
                          v-model="customer.email"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label">
                        {{ $t("Phone") }}</label
                      >
                      <div class="col-sm-10">
                        <input
                          type="text"
                          readonly
                          class="form-control"
                          v-model="customer.phone"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label"> </label>
                      <div class="col-sm-10">
                        <toggle-button
                          class="float-right"
                          v-model="send_email_to_customer"
                          :width="120"
                          :height="35"
                          :labels="{
                            checked: $t('Send_Email'),
                            unchecked: $t('No send email'),
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="container box-payform-inside"
                v-if="container == 'NOTE'"
              >
                <div class="d-flex justify-content-center">
                  <textarea
                    class="form-control mb-4 mt-4"
                    v-model="order_note"
                    rows="8"
                    :placeholder="$t('Add Note on order')"
                    style="border: dashed 2px orange"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <base-customer-list
      v-model="modal_customer"
      v-on:selected="customerSelected"
    />
  </div>
</template> 

<script>
import store from "@/store";
import Swal from "sweetalert2";
import { pay_order } from "@/api/order_list";
import { roundNumber } from '@/utils/helper'
export default {
  name: "BasePaid",
  props: {
    invoice: {
      type: Object,
      default: {},
    },
  },
  data: () => ({
    modal_customer: false,
    cash_receive: 0,
    allExchange: [],
    index_all_exchange: 0,
    payment_type: {},
    creditOption: {},
    paymentTypes: [],
    order_note: "",
    tab_confirm: "",
    print_preview: true,
    customer: {},
    send_email_to_customer: false,
    container: "PAYMENT",
    is_checkout_process: false
  }),
  computed: {
    cashEnter() {
      if (this.allExchange[this.index_all_exchange]) {
        return this.allExchange[this.index_all_exchange].cash_enter.toString();
      }
      return "";
    },

    ValidCheckOut() {
      if (this.isAllowCredit == false && this.cash_change >= 0 && this.is_checkout_process == false) return true;
      if (this.isAllowCredit == true && this.totalCashEnter > 0 && this.is_checkout_process == false) {
        return true;
      }

      return false;
      // if (this.isAllowCredit == false && this.cash_change >= 0) return false;
      // if (this.isAllowCredit == true && Number(this.totalCashEnter) <= 0)
      //   return false;
      // return true;
    },

    isAllowCredit() {
      let find = _.find(this.restaurant.payment_type, function (obj) {
        return obj.title == "Credit";
      });
      if (find) {
        this.creditOption = find;
        return true;
      }
      return false;
    },
    restaurant() {
      return store.getters["restaurant/restaurant"];
    },
    shortcutAmounts() {
      let vm = this;

      let rate = vm.allExchange[vm.index_all_exchange] || {};

      let { amount } = store.getters["restaurant/shortcut"];
      if (amount.length < 1) return [];
      let tmp = _.filter(amount, function (o) {
        return o.currency_code == rate.code;
      })[0];
      if (!tmp) return [];
      return tmp.amount;
    },
    base_currency() {
      return _.find(this.allExchange, function (item) {
        return item.default == true;
      });
    },
    totalCashEnter() {
      var total = 0;
      this.allExchange.forEach((item) => {
        total += item.cash_enter / item.rate;
      });

      return total;
    },
    cash_change() {
      return (
        this.totalCashEnter -
        (this.invoice.amount_to_be_paid - this.invoice.amount_paid)
      );
    },
    loading_order() {
      return store.getters["order/loading_order"];
    },
  },
  methods: {
    setAmountBySort(value, index) {
      this.allExchange[index].cash_enter =
        Number(value) + Number(this.allExchange[index].cash_enter);
    },

    

    exact() {
      let vm = this;
      this.allExchange.forEach((item, index) => {
        vm.allExchange[index].cash_enter = "";
        if (vm.invoice.currency_code == item?.code) {
          vm.allExchange[index].cash_enter = roundNumber((vm.invoice.amount_to_be_paid - vm.invoice.amount_paid) *  vm.invoice.exchangerate, item?.code);
        }
      });
    },
    customerSelected(value) {
      this.customer = value;
      this.modal_customer = false;
    },
    keyNumberChangeAmount(input) {
      if (this.index_all_exchange < 0) {
        this.index_all_exchange = 0;
      }
      this.allExchange[this.index_all_exchange].cash_enter = input;
    },
    async submitOrder() {
 
      let credit_check = _.find(this.restaurant.payment_type, function (obj) {
        return obj.code == "CREDIT";
      });
      if( credit_check?.id == this.payment_type.id ){
          this.allExchange.forEach( (v, index) => {
            this.allExchange[index].cash_enter = 0
          });
      } 

      this.is_checkout_process = true;
      let cash_received = 0;
      this.allExchange.forEach((cash) => {
        cash_received += cash.cash_enter / cash.rate;
      });

      let payload = {
        sale_id: this.invoice.id,
        is_send_email: this.send_email_to_customer,
        cash_received: cash_received,
        customer_id: this.customer.id,
        payment_type_id: this.payment_type.id,
        data_cash_receive: {
          data_cash_enter: this.allExchange,
          data_cash_change: this.cash_change,
        },
      };
      const { data } = await pay_order(payload);
      // console.log(response.data.data);
      // this.invoice = response.data;

      // this.invoice.is_paid = "YES";

      // if (this.customer && this.customer.id) {
      //   this.invoice.customer = this.customer;
      //   this.invoice.customer_id = this.customer.id;
      //   this.invoice.customer_name = this.customer.name;
      // }

      // if (this.cash_change < 0) {
      //   this.invoice.credit = this.cash_change * -1;
      // } else {
      //   this.invoice.credit = 0;
      // }

      // if (
      //   this.invoice.amount_paid + this.cash_receive >=
      //   this.invoice.amount_to_be_paid
      // ) {
      //   this.invoice.amount_paid = this.invoice.amount_to_be_paid;
      // } else {
      //   this.invoice.amount_paid = this.invoice.amount_paid + this.cash_receive;
      // }
      return this.$emit("opened", {
        modal: false,
        print: this.print_preview,
        invoice: data.data,
      });
    },
    async ClosePaid() {
      return this.$emit("opened", {
        modal: false,
        print: false,
        invoice: this.invoice,
      });
    },

    async openModalCredit() {
      if (!this.customer.id) {
        Swal.fire({
          title: this.$i18n.t("Customer is required!"),
          text: this.$i18n.t("Please select a customer!"),
        });
        return null;
      }

      Swal.fire({
        showCancelButton: true,
        confirmButtonText: `Make Credit`,
        title: this.$i18n.t("Cash receive is not equal"),
        text: this.$i18n.t("Do you want to process credit?"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.payment_type = this.creditOption;
          this.submitOrder();
        }
      });
    },
    async makeCredit() {
      if (!this.customer.id) {
        Swal.fire({
          title: this.$i18n.t("Customer is required!"),
          text: this.$i18n.t("Please select a customer!"),
        });
        return;
      }
      await this.submitOrder();
    },
  },
  watch: {
    cash_receive: function (value) {
      this.cash_receive = Number(value);
    },
  },
  mounted() {
    this.allExchange = JSON.parse(this.invoice?.all_exchangerate).map(
      (item) => {
        item.cash_enter = "";
        item.cash_change = 0;
        return item;
      }
    );
    if (this.invoice.customer) {
      this.customer = this.invoice.customer;
    }
    this.payment_type = this.restaurant.payment_type[0];
    this.restaurant.payment_type.forEach((v) => {
      if (v.title != "Credit") this.paymentTypes.push(v);
    });
  },
};
</script>